import { addImageView } from '@core/utils'
import cls from 'classnames'
import { Button, message, Modal, Popconfirm } from 'hljd'
import React, { useEffect, useState } from 'react'
import Api from '../api'
import style from './style.module.less'

const DelCaseModal = ({ visible, onCancel }) => {
  const [caseList, setCaseList] = useState([])
  const [caseNum, setCaseNum] = useState(0)

  useEffect(
    () => {
      if (visible) {
        _queryReferenceCaseList()
      }
    },
    [visible]
  )

  const _queryReferenceCaseList = async () => {
    const { success, data } = await Api.getConsultList()
    if (success) {
      setCaseList(data?.list ?? [])
      setCaseNum(data?.num ?? 0)
    }
  }

  const _delReferenceCase = async id => {
    const { success } = await Api.deleteConsultCase({ set_meal_id: id })
    if (success) {
      message.success('删除成功')
      _queryReferenceCaseList()
    }
  }

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      className={style.modal}
      width={600}
      centered
      footer={null}
      title={'无法发布案例，请至少删除 1 个参考案例后再发布案例'}
    >
      <div className={style.container}>
        <span className={style.tip}>共有{caseNum}个参考案例</span>
        <ul className={style.list}>
          {caseList.map(item => (
            <li key={item.id} className={style.item}>
              <div className={style.coverPath}>
                <img
                  className={style.image}
                  src={addImageView(item.cover_path, 80, 80, 1)}
                />
                {item.is_sold_out == 1 && (
                  <div className={style.soldOut}>已下架</div>
                )}
              </div>
              <span
                className={cls({
                  [style.title]: true,
                  'text-cut-multiline': true
                })}
              >
                {item.title}
              </span>
              <span className={style.clickRate}>
                点击率 {Number(item.ctr_uv) * 100 ?? '0.00'}%
              </span>
              <Popconfirm
                icon={null}
                placement="topRight"
                title="确定删除该案例吗？"
                okText="删除"
                cancelText="取消"
                onConfirm={() => _delReferenceCase(item.id)}
              >
                <Button type="primary" className={style.delete}>
                  删除
                </Button>
              </Popconfirm>
            </li>
          ))}
        </ul>
      </div>
    </Modal>
  )
}

export default DelCaseModal
